import { useState, useCallback } from 'react';
import { Input } from 'antd';
import { getFullName } from '@/utils';
import { useGetChildSearchResultsQuery, useQuickSearchChildrenMutation } from '@/services/child-api';
import Table from '@/components/table';
import Button from '@/components/button';

const ChildQuickSearch = ({ onSelect, text, childId }) => { 
  const [searchText, setSearchText] = useState(text);
  const [searchChildren, { isLoading: loadingSearch }] = useQuickSearchChildrenMutation();

  const [tableModel, setTableModel] = useState({searchId: null, pageNumber: 1, pageSize: 5});
  
  const { data, isFetching } = useGetChildSearchResultsQuery(
    tableModel,
    { skip: !tableModel.searchId },
  );
  
  const onSearch = useCallback(async (value, event, source) => {
    if (loadingSearch) {}
    else if (source.source === 'clear') {
      setTableModel({
        ...tableModel,
        searchId: null
      });
      setSearchText('');
      onSelect();
    }
    else if (value) {
      try {
        const res = await searchChildren({ searchText: value }).unwrap();
        setTableModel({
          ...tableModel,
          searchId: res,
          pageNumber: 1
        });
      } catch (err) {}
    }
  }, [tableModel, loadingSearch, onSelect, searchChildren]);

  const onPageChange = useCallback((val) => {
    setTableModel({...tableModel, pageNumber: val});
  }, [tableModel]);

  const onSearchChange = useCallback((evt) => {
    if(childId)
      evt.preventDefault();
    else
     setSearchText(evt.target.value);
  }, [childId]);

  const onClickSelect = useCallback((record) => {
    var text = getFullName(record.name) + ' (' + record.childCode + ')';
    setTableModel({ ...tableModel, searchId: null});
    setSearchText(text);
    onSelect(record.childId, text);
  }, [tableModel, onSelect]);


  const columns = [
    {
      title: 'Child ID',
      dataIndex: 'childCode',
    },
    {
      title: 'Child',
      dataIndex: 'name',
      render: (value) => getFullName(value),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (value) => value.name,
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Button size="small" onClick={() => onClickSelect(record)}>
          Select
        </Button>
      ),
    },
  ];
  

  return (
    <>
      <Input.Search
        placeholder="Search..."
        allowClear
        value={searchText}
        onChange={onSearchChange}
        //onBeforeInput={onBeforeInput}
        onSearch={onSearch}
        style={{ marginBottom: 16 }}
      />

      {(tableModel.searchId || loadingSearch) && (
        <Table
          columns={columns}
          dataSource={data?.data}
          rowKey="childId"
          loading={loadingSearch || isFetching}
          size="small"
          pagination={
            data?.count > data?.pageSize && {
              size: 'small',
              showQuickJumper: true,
              showSizeChanger: false,
              total: data.count,
              pageSize: data.pageSize,
              current: data.pageNumber,
              onChange: onPageChange,
            }
          }
        />
      )}
    </>
  );
};

export default ChildQuickSearch;
